module.exports = function (e) {
  var t = {};

  function n(o) {
    if (t[o]) return t[o].exports;
    var a = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, o) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (n.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      n.d(o, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return o;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 21);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t) {
  e.exports = require("classnames");
}, function (e, t) {
  e.exports = require("underscore");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o,
      a,
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      i = p(n(5)),
      l = p(n(0)),
      s = p(n(12)),
      u = p(n(1)),
      c = p(n(3)),
      d = n(32);

  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var f = i.default.Stack(),
      h = "\n  position:fixed;\n  z-index:110;\n  opacity:0;\n  transition: opacity .8s cubic-bezier(0, 0.34, 0.45, 1.5);\n",
      m = {
    position: "bottom",
    alignment: "start",
    positionOffset: 5
  },
      b = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right",
    cover: "cover"
  },
      v = function v(e, t, n, o) {
    var a = void 0,
        r = function (e, t, n, o) {
      switch (n) {
        case "start":
          return 0;

        case "center":
          return c.default.contains(["top", "bottom", "cover"], o) ? (e.width - t.width) / 2 : (e.height - t.height) / 2;

        case "end":
          return c.default.contains(["top", "bottom", "cover"], o) ? -(t.width - e.width) : -(t.height - e.height);
      }
    }(e, t, n, o),
        i = document.documentElement,
        l = i.clientWidth,
        s = i.clientHeight;

    switch (o) {
      case "top":
      case "bottom":
      case "cover":
        (a = e.left + r) + t.width > l && (a = l - t.width);
        break;

      case "left":
      case "right":
        (a = e.top + r) + t.height > s && (a = s - t.height);
    }

    return a;
  },
      y = function y(e, t, n) {
    var o = function () {
      switch (n) {
        case "top":
        case "left":
        case "cover":
          return e;

        case "right":
          return document.documentElement.clientWidth - (e + t.width);

        case "bottom":
          return document.documentElement.clientHeight - (e + t.height);
      }
    }();

    return o > 0 ? 0 : Math.abs(o);
  },
      g = function g(e) {
    e.dataTransfer.setData("text/plain", null), e.currentTarget.setAttribute("data-initialX", e.screenX), e.currentTarget.setAttribute("data-initialY", e.screenY);
  },
      O = function O(e) {
    var t = e.screenX,
        n = e.screenY,
        o = e.currentTarget;
    _(o, t, n), o.setAttribute("data-initialX", null), o.setAttribute("data-initialY", null);
  },
      _ = function _(e, t, n) {
    var o = n - e.getAttribute("data-initialY"),
        a = t - e.getAttribute("data-initialX"),
        r = e.offsetTop,
        i = e.offsetLeft;
    e.style.left = i + a + "px", e.style.top = r + o + "px";
  },
      C = (a = o = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.forceClose = n.forceClose.bind(n), n.getContentEl = n.getContentEl.bind(n), n.getTargetEl = n.getTargetEl.bind(n), n.handleBlur = n.handleBlur.bind(n), n.handleKeyDown = n.handleKeyDown.bind(n), n.prepareContent = n.prepareContent.bind(n), n.renderChild = n.renderChild.bind(n), n.unmountChild = n.unmountChild.bind(n), n.targetRef = n.targetRef.bind(n), n.wrappedChildRef = n.wrappedChildRef.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, l.default.Component), r(t, [{
      key: "componentDidMount",
      value: function value() {
        this.renderChild(), window.addEventListener("resize", this.forceClose), window.addEventListener("scroll", this.forceClose, !0);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e;
        window.removeEventListener("resize", this.forceClose), window.removeEventListener("scroll", this.forceClose), this.unmountChild(), this.container && (this.props.draggable && null != (e = this.container) && (e.removeEventListener("dragstart", g), e.removeEventListener("dragend", O)), (0, d.removeHTMLNode)(this.container), null != this.container ? this.container : this.container = null);
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.visible ? this.renderChild(!e.visible) : e.visible && this.unmountChild();
      }
    }, {
      key: "forceClose",
      value: function value() {
        if (this.props.visible) return "function" == typeof this.props.onRequestClose ? this.props.onRequestClose() : void 0;
      }
    }, {
      key: "getContentEl",
      value: function value() {
        var e = this.props,
            t = e.children,
            n = e.content;
        return null != n ? n : 2 === t.length ? c.default.last(l.default.Children.toArray(t)) : null;
      }
    }, {
      key: "getTargetEl",
      value: function value() {
        var e = this.props,
            t = e.target,
            n = e.children;
        return null != t ? t : c.default.first(l.default.Children.toArray(n));
      }
    }, {
      key: "handleBlur",
      value: function value(e) {
        var t = s.default.findDOMNode(this.targetEl),
            n = null != this.container && this.container.contains(e.relatedTarget),
            o = e.relatedTarget === t;
        if (n || o) return e.preventDefault();
        var a = f.first(),
            r = s.default.findDOMNode(a.targetEl);
        return (null != this.wrappedChild ? this.wrappedChild.contains(r) : void 0) ? e.preventDefault() : a !== this && r.contains(t) ? e.preventDefault() : "function" == typeof this.props.onRequestClose ? this.props.onRequestClose(e) : void 0;
      }
    }, {
      key: "handleKeyDown",
      value: function value(e) {
        27 === e.keyCode && this.handleBlur(e);
      }
    }, {
      key: "targetRef",
      value: function value(e) {
        this.targetEl = e;
      }
    }, {
      key: "wrappedChildRef",
      value: function value(e) {
        this.wrappedChild = e;
      }
    }, {
      key: "prepareContent",
      value: function value() {
        var e = this.getContentEl();
        return e ? l.default.createElement("div", {
          className: "PopupBox_Content",
          onKeyDown: this.handleKeyDown,
          onBlur: this.handleBlur,
          ref: this.wrappedChildRef,
          tabIndex: "-1"
        }, e) : null;
      }
    }, {
      key: "renderChild",
      value: function value(e) {
        var t = this;
        null == e && (e = !0), this.props.visible && (null == this.container && (this.container = function (e) {
          null == e && (e = !1);
          var t,
              n = document.createElement("div");
          return n.setAttribute("style", h), n.setAttribute("class", "PopupBox_Container"), e && (n.setAttribute("draggable", !0), null != (t = n) && (t.addEventListener("dragstart", g), t.addEventListener("dragend", O))), document.body.appendChild(n), n;
        }(this.props.draggable)), s.default.render(this.prepareContent(), this.container, function () {
          if (e) return f = f.unshift(t), t.wrappedChild.focus(), function (e, t, n) {
            var o = function (e, t, n) {
              var o = void 0;
              null == n && (n = {});

              var a = c.default.defaults(n, m),
                  r = a.position,
                  i = a.alignment,
                  l = a.positionOffset,
                  s = r,
                  u = e.getBoundingClientRect(),
                  d = t.getBoundingClientRect(),
                  p = function (e, t, n) {
                return function (o) {
                  var a = e[o];

                  switch (o) {
                    case "top":
                      return a - (t.height + n);

                    case "left":
                      return a - (t.width + n);

                    case "bottom":
                    case "right":
                      return a + n;

                    default:
                      return e.top + n;
                  }
                };
              }(u, d, l),
                  f = p(r),
                  h = v(u, d, i, r),
                  g = y(f, d, r);

              if (g > 0) {
                var O = b[r],
                    _ = p(O),
                    C = y(_, d, O);

                0 === C ? (f = _, r = O) : (C < g && (f = _), C < g && (r = O), o = Math.max("50", d.height - Math.min(g, C))), r !== s && (h = v(u, d, i, r));
              }

              return function (e, t, n, o) {
                var a = null != o ? "height:" + o + "px;overflow-y:auto;" : "";

                switch (r) {
                  case "top":
                  case "bottom":
                  case "cover":
                    return a + "top:" + t + "px;left:" + n + "px;";

                  case "right":
                  case "left":
                    return a + "top:" + n + "px;left:" + t + "px;";
                }
              }(0, f, h, o);
            }(t, e, n);

            e.setAttribute("style", h + o + "opacity:1;");
          }(t.container, s.default.findDOMNode(t.targetEl), t.props.positionParams);
        }));
      }
    }, {
      key: "unmountChild",
      value: function value() {
        if (null != this.container && (s.default.unmountComponentAtNode(this.container), this.container.setAttribute("style", h)), f.first() === this) {
          var e = (f = f.shift()).first();

          if (e) {
            var t = s.default.findDOMNode(this.targetEl);
            (null != e.wrappedChild ? e.wrappedChild.contains(t) : void 0) && null != e.wrappedChild && e.wrappedChild.focus();
            var n = s.default.findDOMNode(e.targetEl);
            if (null != t ? t.contains(n) : void 0) return null != e.wrappedChild ? e.wrappedChild.focus() : void 0;
          }
        }
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.getTargetEl();
        return l.default.cloneElement(t, {
          tabIndex: null != t.props.tabIndex ? t.props.tabIndex : 0,
          ref: function ref(n) {
            return "function" == typeof t.ref && t.ref(n), e.targetRef(n);
          }
        });
      }
    }]), t;
  }(), o.propTypes = {
    draggable: u.default.bool,
    visible: u.default.bool.isRequired,
    onRequestClose: u.default.func.isRequired,
    target: u.default.element,
    content: u.default.element,
    positionParams: u.default.shape({
      position: u.default.oneOf(["bottom", "top", "left", "right", "cover"]),
      alignment: u.default.oneOf(["start", "center", "end"]),
      positionOffset: u.default.number
    }),
    children: function children(e, t, n) {
      if (e[t].length > 2) throw new Error(n + " must not have more than 2 child elements.");
      return null;
    }
  }, a);

  t.default = C;
}, function (e, t) {
  e.exports = require("immutable");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = s(n(2)),
      a = s(n(0)),
      r = n(1),
      i = s(n(38)),
      l = s(n(11));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var u = function u(e) {
    var t = e.className,
        n = e.expanded,
        r = e.onClick,
        s = (0, o.default)("ep-expand-button", t, {
      "ep-expand-button--expanded": n,
      "ep-expand-button--collapsed": !n
    });
    return a.default.createElement("button", {
      onClick: r,
      className: s
    }, n ? a.default.createElement(i.default, null) : a.default.createElement(l.default, null));
  };

  u.propTypes = {
    className: r.string,
    expanded: r.bool,
    onClick: r.func.isRequired
  }, u.defaultProps = {
    className: "",
    expanded: !0
  }, t.default = u;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.canUseDOM = void 0;
  var o,
      a = ((o = n(50)) && o.__esModule ? o : {
    default: o
  }).default,
      r = a.canUseDOM ? window.HTMLElement : {};
  t.canUseDOM = a.canUseDOM, t.default = r;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(2)),
      r = n(1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.className,
        n = e.children,
        r = e.colSpan,
        i = (0, a.default)("ep-section__header", t);
    return o.default.createElement("tr", {
      className: i
    }, o.default.createElement("td", {
      colSpan: r
    }, n));
  };

  l.propTypes = {
    colSpan: r.number,
    children: r.node.isRequired,
    className: r.string
  }, l.defaultProps = {
    colSpan: 1,
    className: ""
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o,
      a,
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      i = n(0),
      l = c(i),
      s = n(1),
      u = c(n(2));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var d = (a = o = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.PureComponent), r(t, [{
      key: "btnContent",
      value: function value() {
        var e = {
          label: {},
          icon: {}
        };
        this.props.icon && this.props.alignIcon && (this.props.iconAfter ? (e.label = {
          float: "left"
        }, e.icon = {
          float: "right"
        }) : (e.label = {
          float: "right"
        }, e.icon = {
          float: "left"
        }));
        var t = l.default.createElement("span", {
          key: "label",
          className: this.props.baseStyle + "-btn-label",
          style: e.label
        }, this.props.children || this.props.label);

        if (this.props.icon) {
          var n = [t, l.default.createElement("div", {
            key: "icon",
            className: this.props.baseStyle + "-btn-icon",
            style: e.icon
          }, this.props.icon)];
          return this.props.iconAfter ? n : n.reverse();
        }

        return t;
      }
    }, {
      key: "render",
      value: function value() {
        var e = (0, u.default)(this.props.baseStyle + "-btn", this.props.baseStyle + "-btn--" + this.props.type, this.props.className);
        return l.default.createElement("button", {
          className: e,
          disabled: this.props.disabled,
          style: this.props.style,
          onClick: this.props.onClick,
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur,
          "data-tip": this.props.tooltip || ""
        }, this.btnContent());
      }
    }]), t;
  }(), o.propTypes = {
    baseStyle: s.string,
    className: s.string,
    children: s.node,
    style: (0, s.objectOf)((0, s.oneOfType)([s.string, s.number])),
    type: s.string,
    disabled: s.bool,
    label: s.string,
    icon: (0, s.oneOfType)([s.element, s.string]),
    iconAfter: s.bool,
    alignIcon: s.bool,
    onClick: s.func,
    onFocus: s.func,
    onBlur: s.func,
    tooltip: s.string
  }, o.defaultProps = {
    baseStyle: "ep",
    className: "",
    children: null,
    disabled: !1,
    label: null,
    style: {},
    type: "",
    icon: null,
    iconAfter: !0,
    alignIcon: !0,
    onClick: function onClick() {
      return null;
    },
    onFocus: function onFocus() {
      return null;
    },
    onBlur: function onBlur() {
      return null;
    },
    tooltip: ""
  }, a);
  t.default = d;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = /[A-Z]/g,
      a = /[-_\s]+/g;

  function r(e) {
    return null == e ? "" : "" + e;
  }

  t.default = {
    startsWith: function startsWith(e, t) {
      var n = r(e),
          o = r(t);
      return 0 === n.indexOf(o);
    },
    endsWith: function endsWith(e, t) {
      var n = r(e),
          o = r(t),
          a = n.length - o.length;
      return a >= 0 && n.indexOf(o, a) === a;
    },
    dasherize: function dasherize(e) {
      return r(e).trim().replace(o, "-$1").replace(a, "-").toLowerCase();
    }
  };
}, function (e, t, n) {
  var o = n(0);

  function a(e) {
    return o.createElement("svg", e, [o.createElement("title", {
      key: 0
    }), o.createElement("g", {
      id: "icomoon-ignore",
      key: 1
    }), o.createElement("path", {
      d: "M75.244 178.171h981.209c34.736 0 60.778 26.045 60.778 60.778 0 17.367-8.681 26.045-17.367 43.409l-486.258 555.729c-26.045 26.045-60.778 26.045-86.838 0 0 0 0 0 0 0l-494.951-555.729c-26.045-26.045-17.367-60.778 8.681-86.838 0-8.681 17.367-17.367 34.736-17.367z",
      key: 2
    })]);
  }

  a.displayName = "ArrowDown", a.defaultProps = {
    version: "1.1",
    width: "1123",
    height: "1024",
    viewBox: "0 0 1123 1024"
  }, e.exports = a, a.default = a;
}, function (e, t) {
  e.exports = require("react-dom");
}, function (e, t, n) {
  var o = n(33);

  e.exports = function (e) {
    return o(e).replace(/([A-Z])/g, "-$1").replace(/[-_\s]+/g, "-").toLowerCase();
  };
}, function (e, t) {
  e.exports = function (e) {
    return null == e ? "" : "" + e;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return [].slice.call(e.querySelectorAll("*"), 0).filter(r);
  };
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */

  var o = /input|select|textarea|button|object/;

  function a(e) {
    var t = e.offsetWidth <= 0 && e.offsetHeight <= 0;
    if (t && !e.innerHTML) return !0;
    var n = window.getComputedStyle(e);
    return t ? "visible" !== n.getPropertyValue("overflow") : "none" == n.getPropertyValue("display");
  }

  function r(e) {
    var t = e.getAttribute("tabindex");
    null === t && (t = void 0);
    var n = isNaN(t);
    return (n || t >= 0) && function (e, t) {
      var n = e.nodeName.toLowerCase();
      return (o.test(n) && !e.disabled || "a" === n && e.href || t) && function (e) {
        for (var t = e; t && t !== document.body;) {
          if (a(t)) return !1;
          t = t.parentNode;
        }

        return !0;
      }(e);
    }(e, !n);
  }

  e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.assertNodeList = l, t.setElement = function (e) {
    var t = e;

    if ("string" == typeof t && r.canUseDOM) {
      var n = document.querySelectorAll(t);
      l(n, t), t = "length" in n ? n[0] : n;
    }

    return i = t || i;
  }, t.validateElement = s, t.hide = function (e) {
    s(e) && (e || i).setAttribute("aria-hidden", "true");
  }, t.show = function (e) {
    s(e) && (e || i).removeAttribute("aria-hidden");
  }, t.documentNotReadyOrSSRTesting = function () {
    i = null;
  }, t.resetForTesting = function () {
    i = null;
  };
  var o,
      a = (o = n(49)) && o.__esModule ? o : {
    default: o
  },
      r = n(7),
      i = null;

  function l(e, t) {
    if (!e || !e.length) throw new Error("react-modal: No elements were found for selector " + t + ".");
  }

  function s(e) {
    return !(!e && !i && ((0, a.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), 1));
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(5)),
      r = n(1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.option,
        n = e.onChange,
        a = e.selectedOption;
    return o.default.createElement("label", {
      className: "ep-radiobutton"
    }, o.default.createElement("input", {
      type: "radio",
      className: "ep-radiobutton-input",
      value: t.get("value"),
      checked: t.get("value") === a,
      onChange: n
    }), o.default.createElement("span", {
      className: "ep-radiobutton__label"
    }, t.get("text")), o.default.createElement("br", null));
  };

  l.propTypes = {
    option: (0, r.instanceOf)(a.default.Map).isRequired,
    onChange: r.func.isRequired,
    selectedOption: r.string
  }, l.defaultProps = {
    selectedOption: null
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = l(n(0)),
      a = l(n(2)),
      r = n(1),
      i = l(n(57));

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function s(e) {
    var t = e.index,
        n = e.className,
        r = (0, a.default)("counter", n);
    return o.default.createElement("div", {
      className: r
    }, o.default.createElement(i.default, null), o.default.createElement("div", {
      className: "counter_number"
    }, t));
  };

  s.propTypes = {
    className: r.string,
    index: r.number.isRequired
  }, s.defaultProps = {
    className: ""
  }, t.default = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(2)),
      a = i(n(0)),
      r = i(n(1));

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.className,
        n = e.disabled,
        r = e.label,
        i = e.name,
        l = e.onChange,
        s = e.checked,
        u = (0, o.default)("ep-checkbox", t, {
      disabled: n
    });
    return a.default.createElement("label", {
      className: u
    }, a.default.createElement("input", {
      checked: s,
      className: "ep-checkbox__input",
      disabled: n,
      name: i,
      onChange: l,
      type: "checkbox"
    }), r && a.default.createElement("span", {
      className: "ep-checkbox__label"
    }, r));
  };

  l.propTypes = {
    className: r.default.string,
    disabled: r.default.bool,
    label: r.default.string,
    name: r.default.string.isRequired,
    onChange: r.default.func.isRequired,
    checked: r.default.bool.isRequired
  }, l.defaultProps = {
    className: "",
    disabled: !1
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  },
      a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      r = function r(e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var n = [],
          o = !0,
          a = !1,
          r = void 0;

      try {
        for (var i, l = e[Symbol.iterator](); !(o = (i = l.next()).done) && (n.push(i.value), !t || n.length !== t); o = !0) {
          ;
        }
      } catch (e) {
        a = !0, r = e;
      } finally {
        try {
          !o && l.return && l.return();
        } finally {
          if (a) throw r;
        }
      }

      return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  },
      i = d(n(0)),
      l = d(n(1)),
      s = d(n(62)),
      u = d(n(3)),
      c = d(n(10));

  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function p(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var f = /\.\.\//g,
      h = /[.:]/;

  t.default = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return function (t) {
      var n,
          d,
          m = function m(t, n) {
        var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            i = function i(e) {
          return "\0" + e + "\0";
        },
            l = u.default.extend({}, o, u.default.chain(a).keys().reduce(function (e, t) {
          return e[t] = i(t), e;
        }, {}).value()),
            d = t(function (t) {
          if (c.default.startsWith(t, "/")) return t.substr(1, t.length);

          if (c.default.startsWith(t, "../")) {
            var n = e.split(h);
            if (1 === n.length) return t;
            var o = t.match(f).length,
                a = t.replace(f, "");
            return n.slice(0, n.length - o).concat([a]).join(".").replace(".", ":");
          }

          if (e.length) {
            var r = c.default.endsWith(e, ":") ? "" : ".";
            return "" + e + r + t;
          }

          return t;
        }(n), l);

        if (!u.default.isEmpty(a)) {
          var m = u.default.chain(a).pairs().reduce(function (e, t) {
            var n,
                o = r(e, 2),
                a = o[0],
                l = o[1],
                s = r(t, 2),
                c = s[0],
                d = s[1],
                f = a.split(i(c)),
                h = (p(n = {}, "text_" + c, f[0]), p(n, "comp_" + c, d), n);
            return [f[1], u.default.extend(l, h)];
          }, [d, {}]).value(),
              b = r(m, 2),
              v = b[0],
              y = b[1];
          return y.last = v, (0, s.default)(y);
        }

        return d;
      };

      return d = n = function (e) {
        function n() {
          return function (e, t) {
            if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
          }(this), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (n.__proto__ || Object.getPrototypeOf(n)).apply(this, arguments));
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(n, i.default.PureComponent), a(n, [{
          key: "render",
          value: function value() {
            var e = this.props,
                n = e.i18n,
                a = function (e, t) {
              var n = {};

              for (var o in e) {
                t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
              }

              return n;
            }(e, ["i18n"]),
                r = this.context.i18n,
                l = window.$ && window.$.t,
                s = n || r || l || function (e) {
              return e;
            };

            return i.default.createElement(t, o({
              i18n: u.default.partial(m, s)
            }, a));
          }
        }]), n;
      }(), n.propTypes = {
        i18n: l.default.func
      }, n.defaultProps = {
        i18n: null
      }, n.contextTypes = {
        i18n: l.default.func
      }, d;
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.version = t.translate = t.TextAreaWithApply = t.SelectWithCheckboxes = t.SectionHeaderWithCounter = t.SectionHeaderWithCounterAndExpand = t.SectionHeader = t.SectionRow = t.RadioButtonList = t.RadioWithLabel = t.Popover = t.QuestionsGroup = t.Modal = t.IconButton = t.GuidelineLink = t.ExpandButton = t.DynamicHeightContainer = t.DataTableHeaderCell = t.DataTableHeader = t.DataTableCell = t.DataTableRow = t.DataTableBody = t.DataTable = t.Switcher = t.CustomSelectPopover = t.CustomSelect = t.CellWithTitle = t.CardContent = t.CardHeader = t.Card = t.Button = void 0;
  var o = n(22);
  Object.defineProperty(t, "DataTable", {
    enumerable: !0,
    get: function get() {
      return o.DataTable;
    }
  }), Object.defineProperty(t, "DataTableBody", {
    enumerable: !0,
    get: function get() {
      return o.DataTableBody;
    }
  }), Object.defineProperty(t, "DataTableRow", {
    enumerable: !0,
    get: function get() {
      return o.DataTableRow;
    }
  }), Object.defineProperty(t, "DataTableCell", {
    enumerable: !0,
    get: function get() {
      return o.DataTableCell;
    }
  }), Object.defineProperty(t, "DataTableHeader", {
    enumerable: !0,
    get: function get() {
      return o.DataTableHeader;
    }
  }), Object.defineProperty(t, "DataTableHeaderCell", {
    enumerable: !0,
    get: function get() {
      return o.DataTableHeaderCell;
    }
  });
  var a = n(23);
  Object.defineProperty(t, "version", {
    enumerable: !0,
    get: function get() {
      return a.version;
    }
  }), n(24);

  var r = T(n(9)),
      i = T(n(25)),
      l = T(n(26)),
      s = T(n(27)),
      u = T(n(28)),
      c = T(n(29)),
      d = T(n(31)),
      p = T(n(36)),
      f = T(n(37)),
      h = T(n(6)),
      m = T(n(39)),
      b = T(n(41)),
      v = T(n(43)),
      y = T(n(53)),
      g = T(n(4)),
      O = T(n(17)),
      _ = T(n(54)),
      C = T(n(55)),
      w = T(n(8)),
      E = T(n(56)),
      N = T(n(58)),
      P = T(n(59)),
      k = T(n(61)),
      x = T(n(20));

  function T(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.Button = r.default, t.Card = i.default, t.CardHeader = l.default, t.CardContent = s.default, t.CellWithTitle = u.default, t.CustomSelect = c.default, t.CustomSelectPopover = d.default, t.Switcher = p.default, t.DynamicHeightContainer = f.default, t.ExpandButton = h.default, t.GuidelineLink = m.default, t.IconButton = b.default, t.Modal = v.default, t.QuestionsGroup = y.default, t.Popover = g.default, t.RadioWithLabel = O.default, t.RadioButtonList = _.default, t.SectionRow = C.default, t.SectionHeader = w.default, t.SectionHeaderWithCounterAndExpand = E.default, t.SectionHeaderWithCounter = N.default, t.SelectWithCheckboxes = P.default, t.TextAreaWithApply = k.default, t.translate = x.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.DataTable = t.DataTableBody = t.DataTableHeader = t.DataTableRow = t.DataTableHeaderCell = t.DataTableCell = void 0;

  var o,
      a,
      r,
      i,
      l,
      s,
      u,
      c,
      d,
      p,
      f,
      h,
      m = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      b = n(0),
      v = O(b),
      y = n(1),
      g = O(n(2));

  function O(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function _(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function C(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function w(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  t.DataTableCell = (a = o = function (e) {
    function t() {
      return _(this, t), C(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return w(t, b.PureComponent), m(t, [{
      key: "cellContent",
      value: function value() {
        switch (this.props.type) {
          case "string":
          case "number":
            return this.props.value;

          case "custom":
            return this.props.children;

          default:
            return this.props.value;
        }
      }
    }, {
      key: "render",
      value: function value() {
        return v.default.createElement("td", {
          className: (0, g.default)("ep-data-table-cell", this.props.className)
        }, this.cellContent());
      }
    }]), t;
  }(), o.propTypes = {
    className: y.string,
    type: (0, y.oneOf)(["string", "number", "custom"]),
    value: (0, y.oneOfType)([y.string, y.number]),
    children: y.node
  }, o.defaultProps = {
    className: "",
    type: "string",
    value: null,
    children: null
  }, a), t.DataTableHeaderCell = (i = r = function (e) {
    function t() {
      return _(this, t), C(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return w(t, b.PureComponent), m(t, [{
      key: "render",
      value: function value() {
        return v.default.createElement("th", {
          className: (0, g.default)("ep-data-table-head-cell", this.props.className)
        }, this.props.children);
      }
    }]), t;
  }(), r.propTypes = {
    children: y.node.isRequired,
    className: y.string
  }, r.defaultProps = {
    className: ""
  }, i), t.DataTableRow = (s = l = function (e) {
    function t() {
      return _(this, t), C(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return w(t, b.PureComponent), m(t, [{
      key: "render",
      value: function value() {
        return v.default.createElement("tr", {
          className: (0, g.default)("ep-data-table-row", this.props.className)
        }, this.props.children);
      }
    }]), t;
  }(), l.propTypes = {
    children: y.node.isRequired,
    className: y.string
  }, l.defaultProps = {
    className: ""
  }, s), t.DataTableHeader = (c = u = function (e) {
    function t() {
      return _(this, t), C(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return w(t, b.PureComponent), m(t, [{
      key: "render",
      value: function value() {
        return v.default.createElement("thead", {
          className: (0, g.default)("ep-data-table-header", this.props.className)
        }, this.props.children);
      }
    }]), t;
  }(), u.propTypes = {
    children: y.node.isRequired,
    className: y.string
  }, u.defaultProps = {
    className: ""
  }, c), t.DataTableBody = (p = d = function (e) {
    function t() {
      return _(this, t), C(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return w(t, b.PureComponent), m(t, [{
      key: "render",
      value: function value() {
        return v.default.createElement("tbody", {
          className: (0, g.default)("ep-data-table-body", this.props.className)
        }, v.default.Children.map(this.props.children, function (e) {
          return e;
        }));
      }
    }]), t;
  }(), d.propTypes = {
    children: y.node.isRequired,
    className: y.string
  }, d.defaultProps = {
    className: ""
  }, p), t.DataTable = (h = f = function (e) {
    function t() {
      return _(this, t), C(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return w(t, b.PureComponent), m(t, [{
      key: "render",
      value: function value() {
        var e = (0, g.default)("ep-data-table", this.props.type, this.props.className);
        return v.default.createElement("table", {
          className: e
        }, this.props.children);
      }
    }]), t;
  }(), f.propTypes = {
    className: y.string,
    children: y.node.isRequired,
    type: (0, y.oneOf)(["", "stripped"])
  }, f.defaultProps = {
    className: "",
    type: ""
  }, h);
}, function (e) {
  e.exports = {
    name: "@ep/react-components",
    version: "0.6.3",
    description: "Common React Components Library",
    main: "app/main.js",
    scripts: {
      "build:dev": "jest && webpack",
      "build:prod": "jest && cross-env NODE_ENV=production webpack",
      "build:umd": "cross-env NODE_ENV=production webpack --config scripts/umd.webpack.config",
      "build:copy": "node ./scripts/copy-build-files.js",
      prebuild: "rm -rf ./dist",
      build: "yarn build:prod && yarn build:umd && yarn build:copy",
      release: "yarn build && npm publish dist",
      start: "webpack-dev-server --hot --progress --colors --inline",
      test: "jest",
      "test:watch": "jest --watch",
      "//": "updateSnap script updates snapshots but for some reason return code 1",
      "test:updateSnap": "jest -u --testNamePattern",
      lint: "eslint app; exit 0",
      styleguide: "styleguidist server",
      "styleguide:build": "styleguidist build"
    },
    jest: {
      moduleNameMapper: {
        "\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$": "<rootDir>/app/components/__mocks__/fileMock.js",
        "\\.(css|less)$": "<rootDir>/app/components/__mocks__/styleMock.js"
      }
    },
    author: "Evidence Prime",
    license: "ISC",
    dependencies: {
      underscore: "^1.9.1",
      "underscore.string": "^3.3.5"
    },
    peerDependencies: {
      classnames: "^2.2.5",
      immutable: "^3.8.2",
      "prop-types": "^15.6.1",
      react: "*",
      "react-addons-create-fragment": "^15.6.2",
      "react-modal": "^3.8.1"
    },
    devDependencies: {
      "@storybook/addon-actions": "^3.4.10",
      "@storybook/addon-knobs": "^3.4.10",
      "@storybook/addons": "^3.4.10",
      "@storybook/react": "^3.4.10",
      "babel-core": "^6.26.0",
      "babel-eslint": "^8.0.1",
      "babel-jest": "^22.4.1",
      "babel-loader": "^7.1.2",
      "babel-plugin-transform-decorators-legacy": "^1.3.4",
      "babel-preset-env": "^1.6.1",
      "babel-preset-es2015": "^6.18.0",
      "babel-preset-react": "^6.16.0",
      "babel-preset-stage-0": "^6.16.0",
      classnames: "^2.2.5",
      "copy-webpack-plugin": "^4.5.1",
      "core-js": "^2.6.5",
      "cross-env": "^3.1.4",
      "css-loader": "^2.1.1",
      enzyme: "^3.3.0",
      "enzyme-adapter-react-16": "^1.1.1",
      eslint: "^5.15.1",
      "eslint-config-airbnb": "^16.1.0",
      "eslint-loader": "^2.1.2",
      "eslint-plugin-import": "^2.8.0",
      "eslint-plugin-jsx-a11y": "^6.0.3",
      "eslint-plugin-react": "^7.5.1",
      "file-loader": "^3.0.1",
      "fs-extra": "^6.0.1",
      "html-webpack-plugin": "^3.2.0",
      i18next: "^11.1.1",
      "i18next-xhr-backend": "^1.5.1",
      "image-webpack-loader": "^3.1.0",
      immutable: "^3.8.2",
      jest: "^22.1.4",
      "mini-css-extract-plugin": "^0.5.0",
      "prop-types": "^15.6.1",
      react: "^16.4.0",
      "react-addons-create-fragment": "^15.6.2",
      "react-dom": "^16.4.0",
      "react-hot-loader": "^3.1.3",
      "react-modal": "^3.8.1",
      "react-styleguidist": "^9.0.4",
      "react-test-renderer": "^16.2.0",
      "style-loader": "^0.13.1",
      stylus: "^0.54.5",
      "stylus-loader": "^3.0.2",
      "svg-react-loader": "^0.4.5",
      "uglifyjs-webpack-plugin": "^1.2.5",
      "url-loader": "^1.0.1",
      webpack: "^4.29.6",
      "webpack-cli": "^3.2.3",
      "webpack-dev-server": "^3.2.1",
      "webpack-node-externals": "^1.7.2"
    }
  };
}, function (e, t, n) {}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(2)),
      r = i(n(1));

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.children,
        n = e.className,
        r = e.style;
    return o.default.createElement("div", {
      className: (0, a.default)("ep-card", n),
      style: r
    }, t);
  };

  l.propTypes = {
    children: r.default.node.isRequired,
    className: r.default.string,
    style: r.default.object
  }, l.defaultProps = {
    className: "",
    style: {}
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = r(n(0)),
      a = r(n(1));

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var i = function i(e) {
    var t = e.title,
        n = e.children;
    return o.default.createElement("div", {
      className: "card__card-header"
    }, t && o.default.createElement("h1", null, t), n);
  };

  i.propTypes = {
    title: a.default.string,
    children: a.default.node
  }, i.defaultProps = {
    title: null,
    children: null
  }, t.default = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(1)),
      r = i(n(2));

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.className,
        n = e.headerBackground,
        a = e.children;
    return o.default.createElement("div", {
      className: (0, r.default)("card__card-content", t, {
        "header-bg": n
      })
    }, a);
  };

  l.propTypes = {
    className: a.default.string,
    children: a.default.node.isRequired,
    headerBackground: a.default.bool
  }, l.defaultProps = {
    className: "",
    headerBackground: !1
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(2)),
      r = n(1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.className,
        n = e.rowSpan,
        r = e.colSpan,
        i = e.children,
        l = e.cellTitle,
        s = e.style,
        u = (0, a.default)("ep-cell", t);
    return o.default.createElement("td", {
      colSpan: r,
      rowSpan: n,
      className: u,
      style: s
    }, l && o.default.createElement("h2", null, l), o.default.createElement("div", {
      className: "ep-cell__content"
    }, i));
  };

  l.propTypes = {
    className: r.string,
    cellTitle: r.string,
    children: r.node.isRequired,
    colSpan: r.number,
    rowSpan: r.number,
    style: r.object
  }, l.defaultProps = {
    className: "",
    rowSpan: 1,
    colSpan: 1,
    cellTitle: null,
    style: {}
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o,
      a,
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      i = p(n(0)),
      l = n(1),
      s = p(n(2)),
      u = p(n(3)),
      c = p(n(10)),
      d = p(n(11));

  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  n(30);
  var f = (0, l.shape)({
    value: l.string,
    text: l.string,
    disabled: l.bool,
    tooltip: l.string
  }),
      h = (a = o = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return n.onBlur = function () {
        n.container.contains(document.activeElement) || n.setState({
          showingOptions: !1
        });
      }, n.onOptionOver = function (e) {
        if (n.props.onOptionHover) {
          var t = e.target.getAttribute("data-value");
          n.props.onOptionHover(t, e.target);
        }
      }, n.onOptionOut = function () {
        "function" == typeof n.props.onOptionHover && n.props.onOptionHover(null);
      }, n.getInitiallySelectedText = function (e) {
        var t = e.selected,
            n = e.groupedOptions,
            o = e.options;

        if (t) {
          var a = u.default.flatten(o.concat(u.default.pluck(n, "options"))),
              r = u.default.findWhere(a, {
            value: t
          });
          return r ? r.text : "&zwnj;";
        }

        return "&zwnj;";
      }, n.handleSelect = function (e) {
        return function (t) {
          t.stopPropagation(), t.preventDefault(), e.disabled || (e.value !== n.state.selectedValue ? (n.setState({
            selectedValue: e.value,
            selectedText: e.text,
            showingOptions: !1
          }), "function" == typeof n.props.onChange && n.props.onChange(e.value)) : n.setState({
            showingOptions: !1
          }));
        };
      }, n.listRef = function (e) {
        n.listEl = e;
      }, n.toggleOptions = function () {
        n.props.disabled || n.setState({
          showingOptions: !n.state.showingOptions
        });
      }, n.renderOptionsGroup = function (e, t) {
        var o = e.caption,
            a = e.options;
        return i.default.createElement("li", {
          className: "options-group",
          key: t
        }, i.default.createElement("div", {
          className: "options-group__caption"
        }, o), i.default.createElement("div", {
          className: "options-group__options"
        }, i.default.createElement("ul", null, a.map(n.renderOption))));
      }, n.renderOption = function (e, t) {
        var o = e.value,
            a = e.text,
            r = e.disabled,
            l = e.tooltip,
            u = n.state.selectedValue === o,
            d = (0, s.default)("option", c.default.dasherize(o), {
          selected: u
        });
        return i.default.createElement("li", {
          className: d,
          tabIndex: "1",
          "data-index": t,
          "data-value": o,
          onMouseDown: n.handleSelect(e),
          key: t,
          disabled: r,
          "data-tip": l || ""
        }, a);
      }, n.renderSign = function () {
        var e = n.props,
            t = e.signClass,
            o = e.signPosition,
            a = "full-triangle" === t ? i.default.createElement(d.default, null) : "",
            r = (0, s.default)("select-sign", t, {
          left: "left" === o,
          right: "right" === o
        });
        return i.default.createElement("div", {
          className: r
        }, a);
      }, n.state = {
        selectedValue: e.selected,
        selectedText: n.getInitiallySelectedText(e),
        showingOptions: !1
      }, n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.default.PureComponent), r(t, [{
      key: "componentDidUpdate",
      value: function value(e, t) {
        var n = this.state,
            o = n.selectedValue,
            a = n.showingOptions;

        if (o || this.setState({
          selectedText: this.getInitiallySelectedText(this.props)
        }), a && !t.showingOptions) {
          var r = this.container.getBoundingClientRect(),
              i = r.top,
              l = r.height;
          this.listEl.setAttribute("style", "max-height:calc(100vh - " + (i + l + 5) + "px);overflow:auto;");
        }
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = (0, s.default)("options-select-container", this.props.className, {
          expanded: this.state.showingOptions,
          disabled: this.props.disabled
        }),
            n = (0, s.default)("options-container", this.props.listClassName, {
          visible: this.state.showingOptions,
          "with-numbered-options": this.props.withNumberOptions
        }),
            o = this.props.orderedList ? "ol" : "ul";
        return i.default.createElement("div", {
          className: t,
          ref: function ref(t) {
            e.container = t;
          }
        }, i.default.createElement("div", {
          className: "select-input",
          onClick: this.toggleOptions,
          tabIndex: "1",
          onBlur: this.onBlur
        }, "left" === this.props.signPosition && this.renderSign(), i.default.createElement("div", {
          className: "text-box",
          dangerouslySetInnerHTML: {
            __html: this.state.selectedText
          }
        }), "right" === this.props.signPosition && this.renderSign()), i.default.createElement(o, {
          className: n,
          onMouseOver: this.onOptionOver,
          onMouseLeave: this.onOptionOut,
          ref: this.listRef
        }, this.props.groupedOptions.map(this.renderOptionsGroup), this.props.options.map(this.renderOption)));
      }
    }]), t;
  }(), o.propTypes = {
    className: l.string,
    onChange: l.func,
    onOptionHover: l.func,
    signPosition: (0, l.oneOf)(["left", "right"]),
    signClass: l.string,
    listClassName: l.string,
    options: (0, l.arrayOf)(f),
    groupedOptions: (0, l.arrayOf)((0, l.shape)({
      caption: l.string,
      options: (0, l.arrayOf)(f)
    })),
    selected: l.string,
    disabled: l.bool,
    orderedList: l.bool,
    withNumberOptions: l.bool
  }, o.defaultProps = {
    signPosition: "right",
    orderedList: !1,
    withNumberOptions: !1,
    groupedOptions: [],
    options: []
  }, a);
  t.default = h;
}, function (e, t, n) {}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o,
      a,
      r,
      i,
      l = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      s = h(n(0)),
      u = h(n(2)),
      c = h(n(4)),
      d = h(n(1)),
      p = h(n(13)),
      f = h(n(3));

  function h(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function m(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function b(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function v(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  var y = d.default.shape({
    value: d.default.string,
    text: d.default.string,
    disabled: d.default.bool,
    title: d.default.string
  }),
      g = function g(e) {
    var t = f.default.omit(e, ["text", "optionText"]);
    return s.default.createElement("li", t, s.default.createElement("span", null, null != e.optionText ? e.optionText : e.text));
  };

  g.propTypes = {
    text: d.default.string.isRequired,
    optionText: d.default.string
  }, g.defaultProps = {
    optionText: null
  };

  var O = (a = o = function (e) {
    function t(e) {
      m(this, t);
      var n = b(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.state = {
        annotationVisible: !1
      }, n.annotationRef = n.annotationRef.bind(n), n.showAnnotation = n.showAnnotation.bind(n), n.hideAnnotation = n.hideAnnotation.bind(n), n.handleOptionLeave = n.handleOptionLeave.bind(n), n;
    }

    return v(t, s.default.Component), l(t, [{
      key: "annotationRef",
      value: function value(e) {
        this.annotation = e;
      }
    }, {
      key: "showAnnotation",
      value: function value() {
        this.setState({
          annotationVisible: !0
        });
      }
    }, {
      key: "hideAnnotation",
      value: function value() {
        this.setState({
          annotationVisible: !1
        });
      }
    }, {
      key: "handleOptionLeave",
      value: function value(e) {
        e.relatedTarget instanceof Node && (null != this.annotation ? this.annotation.contains(e.relatedTarget) : void 0) || this.hideAnnotation();
      }
    }, {
      key: "render",
      value: function value() {
        var e = f.default.omit(this.props, ["annotation", "label", "commonAnnotation", "annotationClassName", "annotationPosition"]),
            t = (0, u.default)("select-option-annotation", this.props.annotationClassName);
        return s.default.createElement(c.default, {
          visible: this.state.annotationVisible,
          onRequestClose: this.hideAnnotation,
          positionParams: this.props.annotationPosition
        }, s.default.createElement("div", {
          onMouseOver: this.showAnnotation,
          onMouseLeave: this.handleOptionLeave
        }, s.default.createElement(g, e)), s.default.createElement("div", {
          className: t,
          ref: this.annotationRef,
          onMouseLeave: this.hideAnnotation
        }, null != this.props.commonAnnotation ? s.default.createElement("div", {
          style: {
            marginBottom: "10px"
          }
        }, this.props.commonAnnotation) : void 0, null != this.props.label ? s.default.createElement("div", {
          style: {
            fontWeight: "bold",
            marginBottom: "10px"
          }
        }, this.props.label) : void 0, s.default.createElement("div", null, this.props.annotation)));
      }
    }]), t;
  }(), o.propTypes = {
    annotation: d.default.string,
    annotationClassName: d.default.string,
    annotationPosition: d.default.object,
    commonAnnotation: d.default.string,
    label: d.default.string
  }, o.defaultProps = {
    annotation: null,
    annotationClassName: "",
    annotationPosition: {
      positionOffset: 0,
      position: "right"
    },
    commonAnnotation: null,
    label: null
  }, a),
      _ = (i = r = function (e) {
    function t(e) {
      m(this, t);
      var n = b(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.state = {
        selectedValue: n.props.selected,
        selectedText: n.getInitiallySelectedText(),
        showingOptions: !1
      }, n.getInitiallySelectedText = n.getInitiallySelectedText.bind(n), n.toggleOptions = n.toggleOptions.bind(n), n.toggleOptions = n.toggleOptions.bind(n), n.showOptions = n.showOptions.bind(n), n.hideOptions = n.hideOptions.bind(n), n.onOptionOver = n.onOptionOver.bind(n), n.onOptionOut = n.onOptionOut.bind(n), n.handleSelect = n.handleSelect.bind(n), n.handleOptionClear = n.handleOptionClear.bind(n), n.renderOptionsGroup = n.renderOptionsGroup.bind(n), n.renderOption = n.renderOption.bind(n), n._containerRef = n._containerRef.bind(n), n.storeContainerWidth = n.storeContainerWidth.bind(n), n;
    }

    return v(t, s.default.Component), l(t, [{
      key: "_containerRef",
      value: function value(e) {
        this.container = e;
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.storeContainerWidth(), window.addEventListener("resize", this.storeContainerWidth);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("resize", this.storeContainerWidth);
      }
    }, {
      key: "storeContainerWidth",
      value: function value() {
        this.setState({
          containerWidth: this.container.offsetWidth
        });
      }
    }, {
      key: "getInitiallySelectedText",
      value: function value() {
        if (this.props.selected) {
          var e = f.default.flatten(this.props.options.concat(f.default.pluck(this.props.groupedOptions, "options")));
          return f.default.findWhere(e, {
            value: this.props.selected
          }).text || "&zwnj;";
        }

        return "&zwnj;";
      }
    }, {
      key: "toggleOptions",
      value: function value() {
        this.props.disabled || this.setState({
          showingOptions: !this.state.showingOptions
        });
      }
    }, {
      key: "showOptions",
      value: function value() {
        this.setState({
          showingOptions: !0
        });
      }
    }, {
      key: "hideOptions",
      value: function value() {
        this.setState({
          showingOptions: !1
        });
      }
    }, {
      key: "onOptionOver",
      value: function value(e) {
        if (this.props.onOptionHover) {
          var t = e.target.getAttribute("data-value");
          this.props.onOptionHover(t, e.target);
        }
      }
    }, {
      key: "onOptionOut",
      value: function value(e) {
        "function" == typeof this.props.onOptionLeave && this.props.onOptionLeave(e);
      }
    }, {
      key: "handleSelect",
      value: function value(e) {
        var t = this;
        return function (n) {
          if (n.stopPropagation(), n.preventDefault(), !e.disabled && e.value !== t.state.selectedValue) return t.setState({
            selectedValue: e.value,
            selectedText: e.text,
            showingOptions: !1
          }), "function" == typeof t.props.onChange ? t.props.onChange(e.value) : void 0;
        };
      }
    }, {
      key: "handleOptionClear",
      value: function value() {
        this.hideOptions(), this.props.onChange(null);
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t) {
        e !== this.props && this.setState({
          selectedText: this.getInitiallySelectedText()
        });
      }
    }, {
      key: "renderOptionsGroup",
      value: function value(e, t) {
        var n = e.caption,
            o = e.options;
        return s.default.createElement("li", {
          className: "options-group",
          key: t
        }, s.default.createElement("div", {
          className: "options-group__caption"
        }, n), s.default.createElement("div", {
          className: "options-group__options"
        }, s.default.createElement("ul", null, o.map(this.renderOption))));
      }
    }, {
      key: "renderOption",
      value: function value(e, t) {
        var n = e.value,
            o = e.text,
            a = e.optionText,
            r = e.disabled,
            i = e.title,
            l = e.annotation,
            c = e.label,
            d = this.state.selectedValue === n,
            f = {
          className: (0, u.default)("option", (0, p.default)(n), {
            selected: d
          }),
          "data-index": t,
          "data-value": n,
          onClick: this.handleSelect(e),
          key: t,
          disabled: r,
          title: i,
          text: o,
          optionText: a
        };
        return l ? s.default.createElement(O, Object.assign({}, f, {
          annotation: l,
          label: c,
          commonAnnotation: this.props.commonAnnotation,
          annotationClassName: this.props.annotationClassName,
          annotationPosition: this.props.annotationPosition
        })) : s.default.createElement(g, Object.assign({}, f));
      }
    }, {
      key: "render",
      value: function value() {
        var e = (0, u.default)("options-select-container", this.props.className, {
          disabled: this.props.disabled,
          "showing-options": this.state.showingOptions
        }),
            t = (0, u.default)("select-input", "sign-position-" + this.props.signPosition),
            n = (0, u.default)("options-select-container__options", this.props.listClassName, {
          "with-numbered-options": this.props.withNumberOptions
        }),
            o = (0, u.default)("select-sign", this.props.signClass),
            a = this.props.orderedList ? "ol" : "ul";
        return s.default.createElement(c.default, {
          visible: this.state.showingOptions,
          onRequestClose: this.hideOptions,
          positionParams: {
            positionOffset: 0
          }
        }, s.default.createElement("div", {
          className: e,
          onClick: this.props.disabled ? void 0 : this.toggleOptions,
          ref: this._containerRef
        }, s.default.createElement("div", {
          className: t
        }, s.default.createElement("div", {
          className: "text-box",
          dangerouslySetInnerHTML: {
            __html: this.state.selectedText
          }
        }), s.default.createElement("div", {
          className: o
        }))), s.default.createElement(a, {
          className: n,
          onMouseOver: this.onOptionOver,
          onMouseLeave: this.onOptionOut,
          style: {
            minWidth: this.state.containerWidth + "px"
          }
        }, this.props.groupedOptions.map(this.renderOptionsGroup), this.props.options.map(this.renderOption), this.props.withClearOption && this.props.selected ? s.default.createElement("li", {
          className: "clear-option btn-popup",
          onClick: this.handleOptionClear
        }, this.props.i18n("actions.clear")) : null));
      }
    }]), t;
  }(), r.propTypes = {
    annotationClassName: d.default.string,
    annotationPosition: d.default.object,
    commonAnnotation: d.default.string,
    className: d.default.string,
    onChange: d.default.func,
    onOptionHover: d.default.func,
    onOptionLeave: d.default.func,
    i18n: d.default.func.isRequired,
    signPosition: d.default.oneOf(["left", "right"]),
    signClass: d.default.string,
    listClassName: d.default.string,
    options: d.default.arrayOf(y).isRequired,
    groupedOptions: d.default.arrayOf(d.default.shape({
      caption: d.default.string,
      options: d.default.arrayOf(y)
    })),
    selected: d.default.string,
    disabled: d.default.bool,
    orderedList: d.default.bool,
    withNumberOptions: d.default.bool,
    withClearOption: d.default.bool
  }, r.defaultProps = {
    annotationClassName: "",
    annotationPosition: {
      positionOffset: 0,
      position: "right"
    },
    commonAnnotation: null,
    signPosition: "right",
    orderedList: !1,
    withNumberOptions: !1,
    groupedOptions: [],
    withClearOption: !1
  }, i);

  t.default = _;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.removeHTMLNode = function (e) {
    return null != e.remove ? e.remove() : e.removeNode(!0);
  };
}, function (e, t, n) {
  var o = n(14),
      a = n(34),
      r = String.prototype.trim;

  e.exports = function (e, t) {
    return e = o(e), !t && r ? r.call(e) : (t = a(t), e.replace(new RegExp("^" + t + "+|" + t + "+$", "g"), ""));
  };
}, function (e, t, n) {
  var o = n(35);

  e.exports = function (e) {
    return null == e ? "\\s" : e.source ? e.source : "[" + o(e) + "]";
  };
}, function (e, t, n) {
  var o = n(14);

  e.exports = function (e) {
    return o(e).replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(2)),
      r = n(1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.buttonText,
        n = e.checked,
        r = e.className,
        i = e.disabled,
        l = e.onChange;
    return o.default.createElement("div", {
      className: (0, a.default)("ep-switcher", r)
    }, o.default.createElement("label", {
      className: "ep-switcher__switcher",
      onClick: i ? null : l
    }, o.default.createElement("input", {
      className: "hidden",
      type: "checkbox",
      disabled: "disabled",
      checked: n
    }), o.default.createElement("div", {
      className: (0, a.default)("switcher__slider", {
        disabled: i
      })
    })), t && o.default.createElement("button", {
      onClick: l,
      disabled: i
    }, o.default.createElement("span", {
      className: "ep-switcher__switch-btn-text"
    }, t)));
  };

  l.propTypes = {
    buttonText: r.node,
    className: r.string,
    checked: r.bool,
    disabled: r.bool,
    onChange: r.func.isRequired
  }, l.defaultProps = {
    checked: !1,
    disabled: !1,
    className: null,
    buttonText: null
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o,
      a,
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      i = u(n(0)),
      l = u(n(2)),
      s = u(n(1));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = {
    childList: !0,
    subtree: !0,
    characterData: !0,
    attributes: !0
  },
      d = (a = o = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.container = null, n.innerContainer = null, n._ref = n._ref.bind(n), n._refInner = n._refInner.bind(n), n.updateContainerHeight = n.updateContainerHeight.bind(n), n.handleTransitionEnd = n.handleTransitionEnd.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.default.Component), r(t, [{
      key: "componentDidMount",
      value: function value() {
        this.updateContainerHeight(), window.MutationObserver && (this.observer = new window.MutationObserver(this.updateContainerHeight), this.observer.observe(this.innerContainer, c));
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t) {
        this.observer || this.updateContainerHeight();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.observer && (this.observer.disconnect(), this.observer = null);
      }
    }, {
      key: "_ref",
      value: function value(e) {
        this.container = e;
      }
    }, {
      key: "_refInner",
      value: function value(e) {
        this.innerContainer = e;
      }
    }, {
      key: "updateContainerHeight",
      value: function value(e) {
        var t = this.innerContainer.scrollHeight;
        this.container.style.height = t + "px";
      }
    }, {
      key: "handleTransitionEnd",
      value: function value(e) {
        e.target.classList.contains("ep-dynamic-height-container") && this.updateContainerHeight();
      }
    }, {
      key: "render",
      value: function value() {
        return i.default.createElement("div", {
          className: (0, l.default)("ep-dynamic-height-container", this.props.className),
          ref: this._ref,
          onTransitionEnd: this.handleTransitionEnd
        }, i.default.createElement("div", {
          className: "ep-dynamic-height-container__inner",
          ref: this._refInner
        }, this.props.children));
      }
    }]), t;
  }(), o.propTypes = {
    children: s.default.node.isRequired,
    className: s.default.string
  }, o.defaultProps = {
    className: ""
  }, a);
  t.default = d;
}, function (e, t, n) {
  var o = n(0);

  function a(e) {
    return o.createElement("svg", e, [o.createElement("title", {
      key: 0
    }), o.createElement("g", {
      id: "icomoon-ignore",
      key: 1
    }), o.createElement("path", {
      d: "M1020.629 847.476h-944.613c-0.142 0.002-0.305 0.003-0.472 0.003-31.833 0-57.623-25.8-57.623-57.623 0-14.788 5.569-28.275 14.723-38.48l471.004-538.65c10.517-11.041 25.341-17.919 41.754-17.919s31.237 6.874 41.742 17.888l475.248 538.725c9.118 10.146 14.686 23.638 14.686 38.435 0 31.413-25.133 56.958-56.39 57.618z",
      key: 2
    })]);
  }

  a.displayName = "ArrowUp", a.defaultProps = {
    version: "1.1",
    width: "1095",
    height: "1024",
    viewBox: "0 0 1095 1024"
  }, e.exports = a, a.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o,
      a = (o = n(0)) && o.__esModule ? o : {
    default: o
  },
      r = n(1);
  n(40);

  var i = function i(e) {
    var t = e.authors,
        n = e.profileTitle,
        o = e.guidelineTitle,
        r = e.profileId,
        i = e.guidelineId,
        l = e.baseUrl,
        s = l + "/profile/" + r,
        u = l + "/guideline/" + i;
    return a.default.createElement("div", null, t && a.default.createElement("div", {
      className: "ep-guideline-link-authors"
    }, t), a.default.createElement("div", {
      className: "ep-guideline-link-profile"
    }, a.default.createElement("a", {
      href: s,
      target: "_blank",
      rel: "noopener noreferrer",
      dangerouslySetInnerHTML: {
        __html: n
      }
    })), a.default.createElement("div", {
      className: "ep-guideline-link-guideline"
    }, a.default.createElement("a", {
      href: u,
      target: "_blank",
      rel: "noopener noreferrer"
    }, o)));
  };

  i.propTypes = {
    authors: r.string,
    profileTitle: r.string.isRequired,
    guidelineTitle: r.string.isRequired,
    profileId: r.string.isRequired,
    guidelineId: r.string.isRequired,
    baseUrl: r.string.isRequired
  }, i.defaultProps = {
    authors: null
  }, t.default = i;
}, function (e, t, n) {}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(1)),
      r = i(n(2));

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  n(42);

  var l = function l(e) {
    var t = e.iconName,
        n = e.label,
        a = e.disabled,
        i = e.displayLabel,
        l = e.title,
        s = e.className,
        u = e.onClick,
        c = (0, r.default)(s, "btn-icon-container", {
      disabled: a
    }),
        d = (0, r.default)("btn", "btn-icon", t, {
      disabled: a
    });
    return o.default.createElement("div", {
      className: c,
      onClick: function onClick(e) {
        a || u(e);
      }
    }, o.default.createElement("div", {
      className: d,
      "data-tip": l
    }), i && o.default.createElement("div", {
      className: "label-text"
    }, n));
  };

  l.propTypes = {
    iconName: a.default.string.isRequired,
    onClick: a.default.func,
    label: a.default.string,
    disabled: a.default.bool,
    displayLabel: a.default.bool,
    title: a.default.string,
    className: a.default.string
  }, l.defaultProps = {
    onClick: function onClick() {},
    label: null,
    title: null,
    className: null,
    disabled: !1,
    displayLabel: !1
  }, t.default = l;
}, function (e, t, n) {}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o,
      a,
      r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  },
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      l = p(n(2)),
      s = p(n(0)),
      u = p(n(44)),
      c = p(n(3)),
      d = n(1);

  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var f = (a = o = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, s.default.Component), i(t, [{
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.className,
            n = e.closeTimeoutMS,
            o = e.children,
            a = e.isOpen,
            i = e.title,
            d = e.modalSize,
            p = e.overlayClassName,
            f = e.position,
            h = e.scrollableContent,
            m = function (e, t) {
          var n = {};

          for (var o in e) {
            t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
          }

          return n;
        }(e, ["className", "closeTimeoutMS", "children", "isOpen", "title", "modalSize", "overlayClassName", "position", "scrollableContent"]);

        return s.default.createElement(u.default, r({
          className: (0, l.default)("ep-modal", d, {
            "scrolling-content": h
          }, t),
          closeTimeoutMS: n,
          isOpen: a,
          overlayClassName: (0, l.default)("ep-modal__overlay", f, p, {
            "scrolling-container": !h
          })
        }, m), s.default.createElement("div", {
          className: "ep-modal__content"
        }, !c.default.isEmpty(i) && s.default.createElement("h2", null, i), o));
      }
    }]), t;
  }(), o.propTypes = {
    className: d.string,
    closeTimeoutMS: d.number,
    children: d.node,
    isOpen: d.bool.isRequired,
    modalSize: (0, d.oneOf)(["small", "auto", "standard", "medium", "large", "full-size"]),
    overlayClassName: d.string,
    position: (0, d.oneOf)(["top", "centered"]),
    scrollableContent: d.bool,
    title: d.string
  }, o.defaultProps = {
    className: "",
    closeTimeoutMS: 500,
    children: null,
    modalSize: "full-size",
    overlayClassName: "",
    position: "centered",
    scrollableContent: !1,
    title: null
  }, a);
  t.default = f;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o,
      a = (o = n(45)) && o.__esModule ? o : {
    default: o
  };
  t.default = a.default, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.bodyOpenClassName = t.portalClassName = void 0;

  var o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  },
      a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      r = n(0),
      i = h(r),
      l = h(n(12)),
      s = h(n(1)),
      u = h(n(46)),
      c = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }(n(16)),
      d = n(7),
      p = h(d),
      f = n(52);

  function h(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function m(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var b = t.portalClassName = "ReactModalPortal",
      v = t.bodyOpenClassName = "ReactModal__Body--open",
      y = void 0 !== l.default.createPortal,
      g = function g() {
    return y ? l.default.createPortal : l.default.unstable_renderSubtreeIntoContainer;
  };

  function O(e) {
    return e();
  }

  var _ = function (e) {
    function t() {
      var e, n, a;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      for (var r = arguments.length, s = Array(r), c = 0; c < r; c++) {
        s[c] = arguments[c];
      }

      return n = a = m(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), a.removePortal = function () {
        !y && l.default.unmountComponentAtNode(a.node), O(a.props.parentSelector).removeChild(a.node);
      }, a.portalRef = function (e) {
        a.portal = e;
      }, a.renderPortal = function (e) {
        var n = g()(a, i.default.createElement(u.default, o({
          defaultStyles: t.defaultStyles
        }, e)), a.node);
        a.portalRef(n);
      }, m(a, n);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, r.Component), a(t, [{
      key: "componentDidMount",
      value: function value() {
        d.canUseDOM && (y || (this.node = document.createElement("div")), this.node.className = this.props.portalClassName, O(this.props.parentSelector).appendChild(this.node), !y && this.renderPortal(this.props));
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function value(e) {
        return {
          prevParent: O(e.parentSelector),
          nextParent: O(this.props.parentSelector)
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t, n) {
        if (d.canUseDOM) {
          var o = this.props,
              a = o.isOpen,
              r = o.portalClassName;
          e.portalClassName !== r && (this.node.className = r);
          var i = n.prevParent,
              l = n.nextParent;
          l !== i && (i.removeChild(this.node), l.appendChild(this.node)), (e.isOpen || a) && !y && this.renderPortal(this.props);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        if (d.canUseDOM && this.node && this.portal) {
          var e = this.portal.state,
              t = Date.now(),
              n = e.isOpen && this.props.closeTimeoutMS && (e.closesAt || t + this.props.closeTimeoutMS);
          n ? (e.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, n - t)) : this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function value() {
        return d.canUseDOM && y ? (!this.node && y && (this.node = document.createElement("div")), g()(i.default.createElement(u.default, o({
          ref: this.portalRef,
          defaultStyles: t.defaultStyles
        }, this.props)), this.node)) : null;
      }
    }], [{
      key: "setAppElement",
      value: function value(e) {
        c.setElement(e);
      }
    }]), t;
  }();

  _.propTypes = {
    isOpen: s.default.bool.isRequired,
    style: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    portalClassName: s.default.string,
    bodyOpenClassName: s.default.string,
    htmlOpenClassName: s.default.string,
    className: s.default.oneOfType([s.default.string, s.default.shape({
      base: s.default.string.isRequired,
      afterOpen: s.default.string.isRequired,
      beforeClose: s.default.string.isRequired
    })]),
    overlayClassName: s.default.oneOfType([s.default.string, s.default.shape({
      base: s.default.string.isRequired,
      afterOpen: s.default.string.isRequired,
      beforeClose: s.default.string.isRequired
    })]),
    appElement: s.default.instanceOf(p.default),
    onAfterOpen: s.default.func,
    onRequestClose: s.default.func,
    closeTimeoutMS: s.default.number,
    ariaHideApp: s.default.bool,
    shouldFocusAfterRender: s.default.bool,
    shouldCloseOnOverlayClick: s.default.bool,
    shouldReturnFocusAfterClose: s.default.bool,
    parentSelector: s.default.func,
    aria: s.default.object,
    data: s.default.object,
    role: s.default.string,
    contentLabel: s.default.string,
    shouldCloseOnEsc: s.default.bool,
    overlayRef: s.default.func,
    contentRef: s.default.func
  }, _.defaultProps = {
    isOpen: !1,
    portalClassName: b,
    bodyOpenClassName: v,
    role: "dialog",
    ariaHideApp: !0,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: !0,
    shouldCloseOnEsc: !0,
    shouldCloseOnOverlayClick: !0,
    shouldReturnFocusAfterClose: !0,
    parentSelector: function parentSelector() {
      return document.body;
    }
  }, _.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  }, (0, f.polyfill)(_), t.default = _;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  },
      a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      i = n(0),
      l = m(i),
      s = m(n(1)),
      u = h(n(47)),
      c = m(n(48)),
      d = h(n(16)),
      p = h(n(51)),
      f = m(n(7));

  function h(e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t.default = e, t;
  }

  function m(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var b = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  },
      v = 9,
      y = 27,
      g = 0,
      O = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.setOverlayRef = function (e) {
        n.overlay = e, n.props.overlayRef && n.props.overlayRef(e);
      }, n.setContentRef = function (e) {
        n.content = e, n.props.contentRef && n.props.contentRef(e);
      }, n.afterClose = function () {
        var e = n.props,
            t = e.appElement,
            o = e.ariaHideApp,
            a = e.htmlOpenClassName,
            r = e.bodyOpenClassName;
        r && p.remove(document.body, r), a && p.remove(document.getElementsByTagName("html")[0], a), o && g > 0 && 0 == (g -= 1) && d.show(t), n.props.shouldFocusAfterRender && (n.props.shouldReturnFocusAfterClose ? (u.returnFocus(), u.teardownScopedFocus()) : u.popWithoutFocus()), n.props.onAfterClose && n.props.onAfterClose();
      }, n.open = function () {
        n.beforeOpen(), n.state.afterOpen && n.state.beforeClose ? (clearTimeout(n.closeTimer), n.setState({
          beforeClose: !1
        })) : (n.props.shouldFocusAfterRender && (u.setupScopedFocus(n.node), u.markForFocusLater()), n.setState({
          isOpen: !0
        }, function () {
          n.setState({
            afterOpen: !0
          }), n.props.isOpen && n.props.onAfterOpen && n.props.onAfterOpen();
        }));
      }, n.close = function () {
        n.props.closeTimeoutMS > 0 ? n.closeWithTimeout() : n.closeWithoutTimeout();
      }, n.focusContent = function () {
        return n.content && !n.contentHasFocus() && n.content.focus();
      }, n.closeWithTimeout = function () {
        var e = Date.now() + n.props.closeTimeoutMS;
        n.setState({
          beforeClose: !0,
          closesAt: e
        }, function () {
          n.closeTimer = setTimeout(n.closeWithoutTimeout, n.state.closesAt - Date.now());
        });
      }, n.closeWithoutTimeout = function () {
        n.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, n.afterClose);
      }, n.handleKeyDown = function (e) {
        e.keyCode === v && (0, c.default)(n.content, e), n.props.shouldCloseOnEsc && e.keyCode === y && (e.stopPropagation(), n.requestClose(e));
      }, n.handleOverlayOnClick = function (e) {
        null === n.shouldClose && (n.shouldClose = !0), n.shouldClose && n.props.shouldCloseOnOverlayClick && (n.ownerHandlesClose() ? n.requestClose(e) : n.focusContent()), n.shouldClose = null;
      }, n.handleContentOnMouseUp = function () {
        n.shouldClose = !1;
      }, n.handleOverlayOnMouseDown = function (e) {
        n.props.shouldCloseOnOverlayClick || e.target != n.overlay || e.preventDefault();
      }, n.handleContentOnClick = function () {
        n.shouldClose = !1;
      }, n.handleContentOnMouseDown = function () {
        n.shouldClose = !1;
      }, n.requestClose = function (e) {
        return n.ownerHandlesClose() && n.props.onRequestClose(e);
      }, n.ownerHandlesClose = function () {
        return n.props.onRequestClose;
      }, n.shouldBeClosed = function () {
        return !n.state.isOpen && !n.state.beforeClose;
      }, n.contentHasFocus = function () {
        return document.activeElement === n.content || n.content.contains(document.activeElement);
      }, n.buildClassName = function (e, t) {
        var o = "object" === (void 0 === t ? "undefined" : a(t)) ? t : {
          base: b[e],
          afterOpen: b[e] + "--after-open",
          beforeClose: b[e] + "--before-close"
        },
            r = o.base;
        return n.state.afterOpen && (r = r + " " + o.afterOpen), n.state.beforeClose && (r = r + " " + o.beforeClose), "string" == typeof t && t ? r + " " + t : r;
      }, n.attributesFromObject = function (e, t) {
        return Object.keys(t).reduce(function (n, o) {
          return n[e + "-" + o] = t[o], n;
        }, {});
      }, n.state = {
        afterOpen: !1,
        beforeClose: !1
      }, n.shouldClose = null, n.moveFromContentToOverlay = null, n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, i.Component), r(t, [{
      key: "componentDidMount",
      value: function value() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t) {
        this.props.isOpen && !e.isOpen ? this.open() : !this.props.isOpen && e.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !t.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.afterClose(), clearTimeout(this.closeTimer);
      }
    }, {
      key: "beforeOpen",
      value: function value() {
        var e = this.props,
            t = e.appElement,
            n = e.ariaHideApp,
            o = e.htmlOpenClassName,
            a = e.bodyOpenClassName;
        a && p.add(document.body, a), o && p.add(document.getElementsByTagName("html")[0], o), n && (g += 1, d.hide(t));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.className,
            n = e.overlayClassName,
            a = e.defaultStyles,
            r = t ? {} : a.content,
            i = n ? {} : a.overlay;
        return this.shouldBeClosed() ? null : l.default.createElement("div", {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", n),
          style: o({}, i, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, l.default.createElement("div", o({
          ref: this.setContentRef,
          style: o({}, r, this.props.style.content),
          className: this.buildClassName("content", t),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), this.props.children));
      }
    }]), t;
  }();

  O.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, O.propTypes = {
    isOpen: s.default.bool.isRequired,
    defaultStyles: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    style: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    className: s.default.oneOfType([s.default.string, s.default.object]),
    overlayClassName: s.default.oneOfType([s.default.string, s.default.object]),
    bodyOpenClassName: s.default.string,
    htmlOpenClassName: s.default.string,
    ariaHideApp: s.default.bool,
    appElement: s.default.instanceOf(f.default),
    onAfterOpen: s.default.func,
    onAfterClose: s.default.func,
    onRequestClose: s.default.func,
    closeTimeoutMS: s.default.number,
    shouldFocusAfterRender: s.default.bool,
    shouldCloseOnOverlayClick: s.default.bool,
    shouldReturnFocusAfterClose: s.default.bool,
    role: s.default.string,
    contentLabel: s.default.string,
    aria: s.default.object,
    data: s.default.object,
    children: s.default.node,
    shouldCloseOnEsc: s.default.bool,
    overlayRef: s.default.func,
    contentRef: s.default.func,
    testId: s.default.string
  }, t.default = O, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.handleBlur = s, t.handleFocus = u, t.markForFocusLater = function () {
    r.push(document.activeElement);
  }, t.returnFocus = function () {
    var e = null;

    try {
      return void (0 !== r.length && (e = r.pop()).focus());
    } catch (t) {
      console.warn(["You tried to return focus to", e, "but it is not in the DOM anymore"].join(" "));
    }
  }, t.popWithoutFocus = function () {
    r.length > 0 && r.pop();
  }, t.setupScopedFocus = function (e) {
    i = e, window.addEventListener ? (window.addEventListener("blur", s, !1), document.addEventListener("focus", u, !0)) : (window.attachEvent("onBlur", s), document.attachEvent("onFocus", u));
  }, t.teardownScopedFocus = function () {
    i = null, window.addEventListener ? (window.removeEventListener("blur", s), document.removeEventListener("focus", u)) : (window.detachEvent("onBlur", s), document.detachEvent("onFocus", u));
  };
  var o,
      a = (o = n(15)) && o.__esModule ? o : {
    default: o
  },
      r = [],
      i = null,
      l = !1;

  function s() {
    l = !0;
  }

  function u() {
    if (l) {
      if (l = !1, !i) return;
      setTimeout(function () {
        i.contains(document.activeElement) || ((0, a.default)(i)[0] || i).focus();
      }, 0);
    }
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    var n = (0, a.default)(e);

    if (n.length) {
      var o,
          r = t.shiftKey,
          i = n[0],
          l = n[n.length - 1];

      if (e === document.activeElement) {
        if (!r) return;
        o = l;
      }

      if (l !== document.activeElement || r || (o = i), i === document.activeElement && r && (o = l), o) return t.preventDefault(), void o.focus();
      var s = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);

      if (null != s && "Chrome" != s[1] && null == /\biPod\b|\biPad\b/g.exec(navigator.userAgent)) {
        var u = n.indexOf(document.activeElement);
        if (u > -1 && (u += r ? -1 : 1), void 0 === n[u]) return t.preventDefault(), void (o = r ? l : i).focus();
        t.preventDefault(), n[u].focus();
      }
    } else t.preventDefault();
  };
  var o,
      a = (o = n(15)) && o.__esModule ? o : {
    default: o
  };
  e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  e.exports = function () {};
}, function (e, t, n) {
  var o;
  /*!
    Copyright (c) 2015 Jed Watson.
    Based on code that is Copyright 2013-2015, Facebook, Inc.
    All rights reserved.
  */

  /*!
    Copyright (c) 2015 Jed Watson.
    Based on code that is Copyright 2013-2015, Facebook, Inc.
    All rights reserved.
  */

  !function () {
    "use strict";

    var a = !("undefined" == typeof window || !window.document || !window.document.createElement),
        r = {
      canUseDOM: a,
      canUseWorkers: "undefined" != typeof Worker,
      canUseEventListeners: a && !(!window.addEventListener && !window.attachEvent),
      canUseViewport: a && !!window.screen
    };
    void 0 === (o = function () {
      return r;
    }.call(t, n, t, e)) || (e.exports = o);
  }();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.dumpClassLists = function () {};
  var o = {},
      a = {};
  t.add = function (e, t) {
    return n = e.classList, r = "html" == e.nodeName.toLowerCase() ? o : a, void t.split(" ").forEach(function (e) {
      !function (e, t) {
        e[t] || (e[t] = 0), e[t] += 1;
      }(r, e), n.add(e);
    });
    var n, r;
  }, t.remove = function (e, t) {
    return n = e.classList, r = "html" == e.nodeName.toLowerCase() ? o : a, void t.split(" ").forEach(function (e) {
      !function (e, t) {
        e[t] && (e[t] -= 1);
      }(r, e), 0 === r[e] && n.remove(e);
    });
    var n, r;
  };
}, function (e, t, n) {
  "use strict";

  function o() {
    var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
    null != e && this.setState(e);
  }

  function a(e) {
    this.setState(function (t) {
      var n = this.constructor.getDerivedStateFromProps(e, t);
      return null != n ? n : null;
    }.bind(this));
  }

  function r(e, t) {
    try {
      var n = this.props,
          o = this.state;
      this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, o);
    } finally {
      this.props = n, this.state = o;
    }
  }

  function i(e) {
    var t = e.prototype;
    if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
    if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
    var n = null,
        i = null,
        l = null;

    if ("function" == typeof t.componentWillMount ? n = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (n = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? i = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (i = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? l = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (l = "UNSAFE_componentWillUpdate"), null !== n || null !== i || null !== l) {
      var s = e.displayName || e.name,
          u = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
      throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + s + " uses " + u + " but also contains the following legacy lifecycles:" + (null !== n ? "\n  " + n : "") + (null !== i ? "\n  " + i : "") + (null !== l ? "\n  " + l : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
    }

    if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = o, t.componentWillReceiveProps = a), "function" == typeof t.getSnapshotBeforeUpdate) {
      if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
      t.componentWillUpdate = r;
      var c = t.componentDidUpdate;

      t.componentDidUpdate = function (e, t, n) {
        var o = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : n;
        c.call(this, e, t, o);
      };
    }

    return e;
  }

  n.r(t), n.d(t, "polyfill", function () {
    return i;
  }), o.__suppressDeprecationWarning = !0, a.__suppressDeprecationWarning = !0, r.__suppressDeprecationWarning = !0;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  },
      a = l(n(0)),
      r = l(n(1)),
      i = l(n(2));

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function s(e) {
    var t = e.className,
        n = function (e, t) {
      var n = {};

      for (var o in e) {
        t.indexOf(o) >= 0 || Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
      }

      return n;
    }(e, ["className"]);

    return a.default.createElement("div", o({
      className: (0, i.default)("ep-questions-group", t)
    }, n));
  };

  s.propTypes = {
    className: r.default.string
  }, s.defaultProps = {
    className: ""
  }, t.default = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = s(n(0)),
      a = n(1),
      r = s(n(5)),
      i = s(n(2)),
      l = s(n(17));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var u = function u(e) {
    var t = e.name,
        n = e.editable,
        a = e.additionalOptions,
        r = e.selectedOption,
        s = e.options,
        u = e.onChange,
        c = e.className,
        d = e.sectionId,
        p = (0, i.default)("ep-radiobuttonlist-fieldset", c);
    return o.default.createElement("fieldset", {
      name: t,
      disabled: !n,
      className: p
    }, s.map(function (e) {
      return o.default.createElement(l.default, {
        key: e.get("value"),
        onChange: u,
        option: e,
        sectionId: d,
        selectedOption: r
      });
    }).toList(), !a.isEmpty() && o.default.createElement("hr", null), a.map(function (e) {
      return o.default.createElement(l.default, {
        key: e.get("value"),
        onChange: u,
        option: e,
        sectionId: d,
        selectedOption: r
      });
    }).toList());
  };

  u.propTypes = {
    additionalOptions: (0, a.instanceOf)(r.default.List),
    className: a.string,
    editable: a.bool,
    name: a.string.isRequired,
    onChange: a.func,
    options: (0, a.instanceOf)(r.default.List).isRequired,
    sectionId: a.string.isRequired,
    selectedOption: a.string
  }, u.defaultProps = {
    additionalOptions: r.default.List(),
    onChange: function onChange() {
      return null;
    },
    editable: !0,
    className: "",
    selectedOption: ""
  }, t.default = u;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = i(n(0)),
      a = i(n(2)),
      r = n(1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function l(e) {
    var t = e.children,
        n = e.className,
        r = e.style;
    return o.default.createElement("tr", {
      className: (0, a.default)("ep-section-row", n),
      style: r
    }, t);
  };

  l.propTypes = {
    children: r.node.isRequired,
    className: r.string,
    style: r.object
  }, l.defaultProps = {
    className: "",
    style: {}
  }, t.default = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = u(n(2)),
      a = u(n(0)),
      r = n(1),
      i = u(n(18)),
      l = u(n(6)),
      s = u(n(8));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var c = function c(e) {
    var t = e.className,
        n = e.children,
        r = e.colSpan,
        u = e.expanded,
        c = e.index,
        d = e.withIndex,
        p = e.onToggle,
        f = e.withToggle,
        h = (0, o.default)(t, "ep-section__header", {
      "ep-section__header--expanded": u,
      "ep-section__header--collapsed": !u
    });
    return a.default.createElement(s.default, {
      className: h,
      colSpan: r
    }, null != c && d && a.default.createElement(i.default, {
      className: "ep-section__header__counter",
      index: c
    }), a.default.createElement("div", {
      className: "ep-section__header__content"
    }, n), f && a.default.createElement("div", {
      className: "ep-section__header__expand-toggler"
    }, a.default.createElement(l.default, {
      expanded: u,
      onClick: p
    })));
  };

  c.propTypes = {
    className: r.string,
    children: r.node.isRequired,
    colSpan: r.number,
    expanded: r.bool,
    index: r.number,
    onToggle: r.func.isRequired,
    withIndex: r.bool,
    withToggle: r.bool
  }, c.defaultProps = {
    className: "",
    colSpan: 1,
    expanded: !0,
    index: 1,
    withIndex: !0,
    withToggle: !0
  }, t.default = c;
}, function (e, t, n) {
  var o = n(0);

  function a(e) {
    return o.createElement("svg", e, [o.createElement("defs", {
      key: 0
    }, o.createElement("style", null, ".cls-1{fill:#ffb563;}.cls-2{fill:#ffa746;}")), o.createElement("title", {
      key: 1
    }, "circle"), o.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2",
      key: 2
    }, o.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    }, [o.createElement("path", {
      className: "cls-1",
      d: "M0,22A22,22,0,0,0,22,44V0A22,22,0,0,0,0,22Z",
      key: 0
    }), o.createElement("path", {
      className: "cls-2",
      d: "M44,22A22,22,0,0,0,22,0V44A22,22,0,0,0,44,22Z",
      key: 1
    })]))]);
  }

  a.displayName = "Circle", a.defaultProps = {
    viewBox: "0 0 44 44"
  }, e.exports = a, a.default = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = l(n(0)),
      a = n(1),
      r = l(n(8)),
      i = l(n(18));

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = function s(e) {
    var t = e.className,
        n = e.children,
        a = e.colSpan,
        l = e.index,
        s = e.withIndex;
    return o.default.createElement(r.default, {
      className: t,
      colSpan: a
    }, l && s && o.default.createElement(i.default, {
      className: "ep-section__header__counter",
      index: l
    }), o.default.createElement("div", {
      className: "ep-section__header__content"
    }, n));
  };

  s.propTypes = {
    colSpan: a.number,
    index: a.number,
    children: a.node.isRequired,
    withIndex: a.bool,
    className: a.string
  }, s.defaultProps = {
    colSpan: 1,
    withIndex: !0,
    index: 1,
    className: ""
  }, t.default = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;

  var o,
      a,
      r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  },
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      l = b(n(2)),
      s = n(0),
      u = b(s),
      c = b(n(1)),
      d = b(n(3)),
      p = b(n(19)),
      f = b(n(6)),
      h = b(n(60)),
      m = b(n(4));

  function b(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var v = c.default.shape({
    value: c.default.string,
    text: c.default.string,
    disabled: c.default.bool,
    title: c.default.string
  }),
      y = function y(e) {
    return d.default.chain(e).values().flatten().value();
  },
      g = function g(e) {
    return d.default.chain(e).map(function (e) {
      return e.options;
    }).flatten().value();
  },
      O = function O(e, t) {
    return e ? [] : d.default.pluck(t, "value");
  },
      _ = function _(e, t) {
    return d.default.contains(e, t) ? d.default.without(e, t) : [].concat(function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }

      return Array.from(e);
    }(e), [t]);
  },
      C = (a = o = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.onChange = function (e, t) {
        return function () {
          var o = n.props,
              a = o.groupedOptions,
              r = o.onChange,
              i = o.selectedOptions;
          if (d.default.isEmpty(a) && "ungrouped" === e) r(_(i, t));else {
            var l = _(i[e], t);

            r(d.default.extend(i, function (e, t, n) {
              return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : e[t] = n, e;
            }({}, e, l)));
          }
        };
      }, n.state = {
        opened: !1
      }, n.allOptionsSelected = n.allOptionsSelected.bind(n), n.getTriggerLabel = n.getTriggerLabel.bind(n), n.hideOptions = n.hideOptions.bind(n), n.isOptionSelected = n.isOptionSelected.bind(n), n.storeContainerWidth = n.storeContainerWidth.bind(n), n.toggleOptions = n.toggleOptions.bind(n), n.toggleAll = n.toggleAll.bind(n), n._containerRef = n._containerRef.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, s.Component), i(t, [{
      key: "componentDidMount",
      value: function value() {
        this.storeContainerWidth(), window.addEventListener("resize", this.storeContainerWidth);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("resize", this.storeContainerWidth);
      }
    }, {
      key: "allOptionsSelected",
      value: function value() {
        var e = this.props,
            t = e.groupedOptions,
            n = e.options,
            o = e.selectedOptions,
            a = y(g(t).concat(n)),
            r = y(o);
        return a.length === r.length;
      }
    }, {
      key: "getTriggerLabel",
      value: function value() {
        var e = this.props,
            t = e.defaultLabel,
            n = e.groupedOptions,
            o = e.options,
            a = e.selectedOptions,
            r = g(n).concat(o),
            i = y(a),
            l = d.default.chain(r).filter(function (e) {
          return function (t) {
            return d.default.contains(e, t.value);
          };
        }(i)).pluck("text").value();
        return d.default.isEmpty(i) ? t : l.join(", ");
      }
    }, {
      key: "hideOptions",
      value: function value() {
        this.setState({
          opened: !1
        });
      }
    }, {
      key: "toggleOptions",
      value: function value() {
        this.props.disabled || this.setState({
          opened: !this.state.opened
        });
      }
    }, {
      key: "toggleAll",
      value: function value() {
        var e = this.props,
            t = e.onChange,
            n = e.groupedOptions,
            o = e.options,
            a = (e.selectedOptions, this.allOptionsSelected());
        if (d.default.isEmpty(n)) t(O(a, o));else {
          var i = O(a, o),
              l = d.default.reduce(n, function (e, t, n) {
            return e[n] = O(a, t.options), e;
          }, {});
          t(r({
            ungrouped: i
          }, l));
        }
      }
    }, {
      key: "_containerRef",
      value: function value(e) {
        this.container = e;
      }
    }, {
      key: "storeContainerWidth",
      value: function value() {
        this.setState({
          containerWidth: this.container.offsetWidth
        });
      }
    }, {
      key: "isOptionSelected",
      value: function value(e, t) {
        var n = this.props,
            o = n.groupedOptions,
            a = n.selectedOptions;
        return d.default.isEmpty(o) && "ungrouped" === e ? d.default.contains(a, t) : d.default.contains(a[e], t);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.className,
            o = t.containerClassName,
            a = t.disabled,
            r = t.groupedOptions,
            i = t.name,
            s = t.options,
            c = t.selectAllLabel,
            b = t.selectedOptions,
            v = t.triggerClassName,
            y = t.withSelectAll,
            g = (0, l.default)("ep-select-with-checkboxes__container", o),
            O = (0, l.default)("ep-select-with-checkboxes", n),
            _ = (0, l.default)("ep-select-with-checkboxes__trigger", v, {
          disabled: a
        });

        return u.default.createElement(m.default, {
          className: O,
          visible: this.state.opened,
          onRequestClose: this.hideOptions,
          positionParams: {
            positionOffset: -1
          }
        }, u.default.createElement("div", {
          ref: this._containerRef,
          className: _,
          onClick: this.toggleOptions
        }, u.default.createElement("div", {
          className: "trigger__label"
        }, this.getTriggerLabel()), u.default.createElement(f.default, {
          onClick: this.toggleOptions,
          expanded: this.state.opened
        })), u.default.createElement("div", {
          style: {
            minWidth: this.state.containerWidth + "px"
          }
        }, u.default.createElement("div", {
          className: g
        }, y && u.default.createElement(p.default, {
          checked: this.allOptionsSelected(),
          className: "select-all",
          name: i,
          label: c,
          onChange: this.toggleAll
        }), !d.default.isEmpty(r) && u.default.createElement(h.default, {
          groupedOptions: r,
          name: i,
          onChange: this.onChange,
          selectedOptions: b
        }), s.map(function (t) {
          return u.default.createElement(p.default, {
            checked: e.isOptionSelected("ungrouped", t.value),
            key: t.value,
            name: i,
            label: t.text,
            onChange: e.onChange("ungrouped", t.value)
          });
        }))));
      }
    }]), t;
  }(), o.propTypes = {
    className: c.default.string,
    containerClassName: c.default.string,
    defaultLabel: c.default.string,
    disabled: c.default.bool,
    name: c.default.string.isRequired,
    groupedOptions: c.default.objectOf(c.default.shape({
      caption: c.default.string.isRequired,
      options: c.default.arrayOf(v).isRequired
    })),
    options: c.default.arrayOf(v),
    onChange: c.default.func.isRequired,
    selectAllLabel: c.default.string,
    selectedOptions: c.default.oneOfType([c.default.arrayOf(c.default.string).isRequired, c.default.objectOf(c.default.arrayOf(c.default.string)).isRequired]).isRequired,
    triggerClassName: c.default.string,
    withSelectAll: c.default.bool
  }, o.defaultProps = {
    className: "",
    containerClassName: "",
    disabled: !1,
    defaultLabel: "select",
    options: [],
    groupedOptions: {},
    selectAllLabel: "select all",
    triggerClassName: "",
    withSelectAll: !0
  }, a);

  t.default = C;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), l(n(13));
  var o = l(n(1)),
      a = l(n(0)),
      r = l(n(3)),
      i = l(n(19));

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = o.default.shape({
    value: o.default.string,
    text: o.default.string,
    disabled: o.default.bool,
    title: o.default.string
  }),
      u = function u(e) {
    var t = e.name,
        n = e.groupedOptions,
        o = e.onChange,
        l = e.selectedOptions;
    return a.default.createElement("div", {
      className: "ep-grouped-checkboxes"
    }, r.default.map(n, function (e, n) {
      return a.default.createElement("div", {
        className: "ep-grouped-checkboxes__group",
        key: n
      }, a.default.createElement("div", {
        className: "ep-grouped-checkboxes__caption"
      }, e.caption), e.options.map(function (e) {
        return a.default.createElement(i.default, {
          checked: r.default.contains(l[n], e.value),
          key: e.value,
          name: t,
          label: e.text,
          onChange: o(n, e.value)
        });
      }));
    }));
  };

  u.propTypes = {
    groupedOptions: o.default.objectOf(o.default.shape({
      caption: o.default.string.isRequired,
      options: o.default.arrayOf(s).isRequired
    })).isRequired,
    name: o.default.string.isRequired,
    onChange: o.default.func.isRequired,
    selectedOptions: o.default.objectOf(o.default.arrayOf(o.default.string)).isRequired
  }, t.default = u;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o,
      a,
      r,
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    return function (t, n, o) {
      return n && e(t.prototype, n), o && e(t, o), t;
    };
  }(),
      l = p(n(0)),
      s = p(n(1)),
      u = p(n(2)),
      c = p(n(20)),
      d = p(n(9));

  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  n(63);
  var f = (0, c.default)()((r = a = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

      return n.onApply = function () {
        n.props.onApply(n.textArea.value), n.close();
      }, n.onBlur = function (e) {
        return e.stopPropagation(), e.relatedTarget && e.relatedTarget.classList.contains("gdt-btn-cancel") ? n.onCancel() : n.onApply();
      }, n.onCancel = function () {
        var e = n.props,
            t = e.onCancel,
            o = e.onApply;
        t ? t() : n.initialContent && n.initialContent !== n.textArea.value && o(n.initialContent), n.close();
      }, n.close = function () {
        n.initialContent = null, n.mounted && n.setState({
          editing: !1
        });
      }, n.textAreaRef = function (e) {
        n.textArea = e;
      }, n.startEditing = function () {
        n.props.readOnly || n.setState({
          editing: !0
        });
      }, n.state = {
        editing: !e.readOnly && e.editing
      }, n.mounted = !1, n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, l.default.PureComponent), i(t, [{
      key: "componentDidMount",
      value: function value() {
        this.mounted = !0;
      }
    }, {
      key: "componentWillUpdate",
      value: function value(e, t) {
        !this.state.editing && t.editing && (this.initialContent = this.props.content);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.mounted = !1;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.i18n,
            n = e.content,
            o = e.readOnly,
            a = this.state.editing,
            r = (0, u.default)({
          editing: a,
          readOnly: o,
          "text-area-container": !0
        });
        return a ? l.default.createElement("div", {
          className: r
        }, l.default.createElement("textarea", {
          ref: this.textAreaRef,
          defaultValue: n,
          onBlur: this.onBlur,
          autoFocus: !0
        }), l.default.createElement("div", {
          className: "buttons"
        }, l.default.createElement(d.default, {
          type: "cancel",
          onClick: this.onCancel,
          label: t("actions.cancel"),
          baseStyle: "gdt"
        }), l.default.createElement(d.default, {
          type: "apply",
          onClick: this.onApply,
          label: t("actions.apply"),
          baseStyle: "gdt"
        }))) : l.default.createElement("div", {
          className: r,
          style: {
            padding: "5px"
          },
          onClick: this.startEditing
        }, n);
      }
    }]), t;
  }(), a.propTypes = {
    i18n: s.default.func.isRequired,
    onApply: s.default.func.isRequired,
    onCancel: s.default.func,
    content: s.default.string,
    readOnly: s.default.bool,
    editing: s.default.bool
  }, a.defaultProps = {
    onCancel: null,
    content: null,
    readOnly: !1,
    editing: !1
  }, o = r)) || o;
  t.default = f;
}, function (e, t) {
  e.exports = require("react-addons-create-fragment");
}, function (e, t, n) {}]);